import { PaymentModuleId } from '@foundation/apis/payments';

import { registerStartupable } from '@/services/base/StartupHelper';

import { triggerRedirectToDenizBank } from './DenizBankApi';
import { OptionalStartupable } from '../base/Startupable';
import PaymentStore from '../payments/PaymentStore';

class DenizBankService implements OptionalStartupable {
  public readonly name = 'DenizBankService';
  public readonly moduleId = PaymentModuleId.DenizBank;

  constructor() {
    registerStartupable(this, [PaymentStore]);
  }
  shouldStart(): boolean {
    return PaymentStore.allowedPaymentModules.includes(this.moduleId);
  }

  public startup(): Promise<void> {
    return Promise.resolve();
  }

  public trigerRedirectToDenizBank(): void {
    return triggerRedirectToDenizBank(PaymentStore.paymentIntentId);
  }
}

export default new DenizBankService();
